import { Text, Heading } from "./typography";
import { Badge } from "./badge";
import { formatDate } from "../../utils/date";
import { IconCircleCheck, IconTruckDelivery } from "@tabler/icons-react";
interface OrderHeaderProps {
    name: string;
    state?: string | null;
    dateOrder?: string | null;
    datePlanned?: string | null;
    validityDate?: string | null;
    validityExpired?: boolean;
    showValidityDate?: boolean;
    isInDelivery?: boolean;
    isDelivered?: boolean;
    deliveredAt?: string | null;
    isInvoiced?: boolean;
    buyerReceived?: boolean | null;
    actions?: React.ReactNode;
}
export function OrderHeader({ name, state, dateOrder, datePlanned, validityDate, validityExpired = false, showValidityDate = false, isInDelivery = false, isDelivered = false, deliveredAt, isInvoiced = false, buyerReceived, actions, }: OrderHeaderProps) {
    return (<div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        <div className="flex items-center gap-3 mb-2">
          <Heading variant="h2" tone="dark">
            {name}
          </Heading>
          {isInvoiced && buyerReceived === false && (<Badge label="Waiting for Confirmation" state="pending"/>)}
          {buyerReceived === true && (<div className="flex items-center gap-2">
              <IconCircleCheck size={20} style={{
                color: "#10B981"
            }}/>
              <Badge label="Validated" state="success"/>
            </div>)}
          {isDelivered && buyerReceived !== true && !(isInvoiced && buyerReceived === false) && (<div className="flex items-center gap-2">
              <IconCircleCheck size={20} style={{
                color: "#10B981"
            }}/>
              <Badge label="Delivered" state="success"/>
            </div>)}
          {isInDelivery && !isDelivered && (<div className="flex items-center gap-2">
              <IconTruckDelivery size={20} style={{
                color: "#F59E0B"
            }}/>
              <Badge label="In Delivery" state="pending"/>
            </div>)}
          {!isDelivered &&
            !isInDelivery &&
            !(isInvoiced && buyerReceived === false) &&
            state?.toLowerCase() === "sale" && (<Badge label="Waiting for Delivery" state="pending"/>)}
        </div>
        <div className="flex flex-wrap items-center gap-4">
          {state && state.toLowerCase() !== "sale" && (<Text variant="body" tone="body">
              State: {state.charAt(0).toUpperCase() + state.slice(1)}
            </Text>)}
          {dateOrder && (<div className="flex items-center gap-2">
              <Text variant="body" tone="body">
                Date:
              </Text>
              <Text variant="body" tone="dark">
                {formatDate(dateOrder)}
              </Text>
            </div>)}
          {datePlanned && (<div className="flex items-center gap-2">
              <Text variant="body" tone="body">
                Planned Date:
              </Text>
              <Text variant="body" tone="dark">
                {formatDate(datePlanned)}
              </Text>
            </div>)}
          {showValidityDate && validityDate && (<div className="flex items-center gap-2">
              <Text variant="body" tone="body">
                Validity Date:
              </Text>
              <div className="flex items-center gap-2">
                <Text variant="body">
                  {formatDate(validityDate)}
                </Text>
                {validityExpired && (<Text variant="bodyXs" className="text-accentError">
                    (Expired)
                  </Text>)}
              </div>
            </div>)}
          {isDelivered && deliveredAt && (<div className="flex items-center gap-2">
              <Text variant="body" tone="body">
                Delivered At:
              </Text>
              <Text variant="body" tone="dark">
                {formatDate(deliveredAt, true)}
              </Text>
            </div>)}
        </div>
      </div>
      {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
    </div>);
}
